import { useTranslation } from 'react-i18next'
import { AddCarRental } from '~/features/africa/Organization/CarRentals/AddCarRental'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'organizations', link: '/organizations/car-rentals' },
  { titleI18n: 'lessors', link: '/organizations/car-rentals' },
  { titleI18n: 'new lessor' },
]

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'requisites', anchor: 'requisites' },
  { labelI18n: 'management', anchor: 'management' },
  { labelI18n: 'contacts', anchor: 'contacts' },
]

export function AddCarRentalPageAfrica() {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('new lessor')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('new lessor')}</PageTitle>
      </Container>
      <AddCarRental />

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
